import { Country } from '@/src/types/apps/resto365Countries'

type locale = 'en-AU' | 'en-US'

const localeCurrencyCodeMapping: Record<locale, string> = {
  'en-AU': 'AUD',
  'en-US': 'USD'
}

const getCurrencyCode = (locale: locale): string => {
  return localeCurrencyCodeMapping[locale]
}

let selectedLocale: locale = 'en-AU'
let selectedLocalCountryCode: Country = Country.AUS

const setSessionLocale = (country: Country) => {
  selectedLocale = country === Country.AUS ? 'en-AU' : 'en-US'
  selectedLocalCountryCode = country
}

const currencyFormat = (amount: number | undefined) => {
  if (amount === undefined || amount === null) {
    return
  }

  return new Intl.NumberFormat(selectedLocale, {
    style: 'currency',
    currency: getCurrencyCode(selectedLocale)
  })
    .format(amount)
    .replace('.00', '')
}

const percentageFormat = (amount: number | undefined) => {
  if (!amount) {
    return
  }

  return `${amount}%`
}

export { setSessionLocale, selectedLocale, selectedLocalCountryCode, currencyFormat, percentageFormat }
